module.exports = __webpack_public_path__ + "img/tp-2.0047644f.png";